import { Component, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { Observable, of, Subject, Subscription } from 'rxjs';
import { DynamicFormCommonConfig } from 'zr-dynamic-form/dynamic-form-common';

import { AbstractControlContainerComponent } from '../../controls/abstract-control-container/abstract-control-container.component';
import { ControlNameService } from '../../services/control-name.service';
import { ControlSharedService } from '../../services/control-shared.service';
import { ControlTranslateService } from '../../services/control-translate.service';
import { ControlValidatorService } from '../../services/control-validator.service';
import { DragService } from '../../services/drag.service';
import { ValidatorNameService } from '../../services/validator-name.service';
import { ToolAdapterService } from '../../tools/tool-adapter.service';
import { AbstractPropertyEditor, AbstractValidatorEditor, DynamicForm, AbstractValueControlBase } from '../../types';
import {
  AbstractContainer,
  AbstractControl,
  ControlDataModel,
  ControlLayoutModel,
  ControlViewModel,
  LayoutControlContainer,
  OptionProperty,
  ControlOperateMode
} from '../../types/control.types';
import { ControlTranslate, findControlByName, getIdentityCode, setControlValidator } from '../../utils';
import { LayoutHostDirective } from '../layout-host.directive';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'layout-designer',
  templateUrl: './layout-designer.component.html',
  styleUrls: ['./layout-designer.component.scss'],
  providers: [ControlTranslateService, ControlSharedService]
})
export class LayoutDesignerComponent extends AbstractControlContainerComponent<any>
  implements DynamicForm, LayoutControlContainer, OnInit, OnDestroy {
  formCode?: string;
  labelCode?: string;
  targetId?: string;
  controls: AbstractControl<ControlViewModel>[];

  @Input()
  set globalData(data: any) {
    this._globalData = data;
    this.controlShared.sendGlobalDataChange(data);
  }
  get globalData(): any {
    return this._globalData;
  }

  @Input() disableOperateControl: boolean;
  @Input()
  set dataModels(dataModels: Array<ControlDataModel>) {
    this._dataModels = dataModels;
    this.loadComponents();
  }
  get dataModels(): Array<ControlDataModel> {
    return this._dataModels;
  }

  @ViewChild(LayoutHostDirective) layoutHost: LayoutHostDirective;

  isContainer: boolean = true;
  children: AbstractControl<ControlViewModel>[] = [];
  control: AbstractContainer<ControlViewModel> = this;
  controlTranslate: ControlTranslate;
  cursor: string; // é¼ æ æ ·å¼

  private _globalData: any;
  private _controlNames: string[]; // æ§ä»¶åç§°
  private _controlIdentityCodes: string[]; // æ§ä»¶åé¨æ è¯
  private _dataModels: Array<ControlDataModel>;
  private _sub: Subscription = new Subscription();

  constructor(
    public controlTranslateService: ControlTranslateService,
    private toolAdapter: ToolAdapterService,
    private dragService: DragService,
    private controlNameService: ControlNameService,
    private validatorNameService: ValidatorNameService,
    private commonConfig: DynamicFormCommonConfig,
    private controlValidatorService: ControlValidatorService,
    controlSharedService: ControlSharedService
  ) {
    super();
    this._controlNames = [];
    this._controlIdentityCodes = [];
    this.controlTranslate = controlTranslateService;
    this.controlShared = controlSharedService;
    this.controlShared.isDesign = true;
  }

  ngOnInit() {
    this.controlTranslate.disableOperateControl = this.disableOperateControl;
    this.controlNameService.handleName = this.handleName.bind(this);
    this.controlNameService.handleCaseCadeParentName = this.handleCasCadeParentName.bind(this);
    this.validatorNameService.handleUnionCheckName = this.handleUnionCheckName.bind(this);

    this._sub.add(
      this.toolAdapter.cursor$.subscribe((s) => {
        this.cursor = s;
      })
    );

    this._sub.add(
      this.controlTranslateService.loadComponentModel$.subscribe((s) => {
        this.controlTranslateService.loadComponentsByModel(s);
      })
    );
    this.subscribeControlResolved();
    this.loadComponents();

    this._sub.add(
      this.controlTranslate.controlRemoved$.subscribe((control) => {
        this.removeControlName(control);
      })
    );
  }

  ngOnDestroy(): void {
    this._sub.unsubscribe();
  }

  /**
   * è®¾ç½®æ§ä»¶éè
   */
  setControlHiddenByName(name: string, isHidden: boolean): void {
    const control = this.findControlByName(name);
    this.setControlHidden(control, isHidden);
  }

  setControlHidden(control: AbstractControl<ControlViewModel>, isHidden: boolean) {
    if (isHidden) {
      control.setModelValue(undefined);
    }

    control.model.isHidden = isHidden;
  }

  /**
   * æ ¹æ®æ§ä»¶åç§°æ¥æ¾æ§ä»¶
   */
  findControlByName(name: string): AbstractControl<ControlViewModel> {
    return findControlByName(name, this.controls);
  }

  // å è½½control
  loadComponents() {
    this._controlNames = [];
    const children = this.controlTranslateService.loadComponents(this.dataModels, this, true);
    this.children.push(...children);
    // å½åæ§ä»¶
    this.controls = this.children;
  }

  getDataModels(): Array<ControlDataModel> {
    const models: ControlDataModel[] = [];
    for (const c of this.children) {
      models.push(c.getDataModel());
    }
    return models;
  }

  addControls(controls: Array<ControlLayoutModel>): Observable<AbstractControl<any>[]> {
    const children = this.controlTranslate.loadComponents(controls, this, true);
    this.children.push(...children);
    return of(children);
  }

  addControl(control: ControlLayoutModel): Observable<AbstractControl<any>> {
    const child = this.controlTranslate.loadComponent(control, this, true);
    this.children.push(child);
    return of(child);
  }

  select() {
    this.toolAdapter.do(this, {});
  }

  // é¼ æ å¨éæ¾çä½ç½®
  @HostListener('mouseup') onMouseup() {
    this.dragService.sendDragEndAtControl(this);
  }

  private subscribeControlResolved() {
    this._sub.add(
      this.controlTranslateService.controlResolved.subscribe((s) => {
        this.setControlsName(s);
        // è¿éè®¾ç½®æAddï¼ç¨æ¥æ¾ç¤ºæ§ä»¶çé»è®¤å¼
        if (s instanceof AbstractValueControlBase) {
          s.operateMode = ControlOperateMode.Add;
        }
        setControlValidator(s, this.controlValidatorService);
        s.controlShared = this.controlShared;
      })
    );
  }

  /**
   * ç§»é¤æ§ä»¶åç§°
   *
   */
  private removeControlName(control: AbstractControl<any>) {
    const controlContainer = ((control as unknown) as LayoutControlContainer).control;
    if (!controlContainer) {
      return;
    }
    if (controlContainer.model) {
      if (controlContainer.model.name) {
        this._controlNames = this._controlNames.filter((s) => s !== controlContainer.model.name);
      }
      if (controlContainer.model.__identityCode) {
        this._controlIdentityCodes = this._controlIdentityCodes.filter(
          (s) => s !== controlContainer.model.__identityCode
        );
      }
    }

    if (controlContainer.children) {
      controlContainer.children.forEach((s) => {
        this.removeControlName(s);
      });
    }
  }

  /**
   * è®¾ç½®æ§ä»¶çåç§°
   *
   */
  private setControlsName(control: AbstractControl<ControlViewModel> | AbstractControl<ControlViewModel>[]) {
    if (control) {
      if (control instanceof Array) {
        control.forEach((s) => {
          this.setControlName(s);
        });
        return;
      }
      this.setControlName(control);
    }
  }

  /**
   * è®¾ç½®æ§ä»¶åç§°ï¼å¦æä¸ºç©ºåèªå¨çææ°ç
   *
   */
  private setControlName(control: AbstractControl<ControlViewModel>) {
    this.setControlIdentityCode(control);
    if (!control.model) {
      control.model = {} as ControlViewModel;
    }
    let code = control.model.name;
    if (!code || this._controlNames.findIndex((s) => s === code) > -1) {
      code = control.model.name = this.getNewControlName(control);
    }
    this._controlNames.push(code);
  }

  /**
   * è·åä¸ä¸ªæ°çæ§ä»¶åç§°ï¼åç§°ä¼æ ¹æ®ç±»åæç§éå¢çé¡ºåºå ä¸ï¼å¦æä¸­é´æç©ºç¼ºåä¼è¡¥ä¸
   *
   */
  private getNewControlName(control: AbstractControl<ControlViewModel>): string {
    // è·åè¯¥ç±»åä¸ï¼æææ§ä»¶çå¼çåºå
    const codeList = this._controlNames
      .filter((s) => {
        return s.startsWith(control.type) && /^[0-9]+$/.test(s.substring(control.type.length, s.length));
      })
      .map((s) => {
        return Number(s.substring(control.type.length, s.length));
      })
      .sort((a, b) => a - b);

    // æç§é¡ºåºï¼è·åç©ºç¼ºçå¼
    let code = control.type;
    if (codeList.length > 0) {
      // è®¡ç®codeNumber
      let codeNumber = 0;

      if (codeList[0] > 1) {
        codeNumber = 1;
      } else {
        for (let i = 0; i < codeList.length; i++) {
          if (i === codeList.length - 1) {
            codeNumber = codeList[codeList.length - 1] + 1;
            break;
          }
          if (codeList[i + 1] - codeList[i] > 1) {
            codeNumber = codeList[i] + 1;
            break;
          }
        }
      }

      if (codeNumber === 0 || codeNumber >= Number.MAX_SAFE_INTEGER) {
        this.commonConfig.dialog.error('æ§ä»¶æ°éå·²è¾¾å°ä¸é');
        return;
      }

      code = code + codeNumber;
    } else {
      code = code + 1;
    }

    return code;
  }

  /**
   * å¤çæ§ä»¶åç§°ï¼å¦æå¤±è´¥åä¼è¿åerror
   *
   */
  private handleName(name: string, editor: AbstractPropertyEditor): Observable<string> {
    if (!name) {
      return this.nameError(`åç§°ä¸è½ä¸ºç©º`);
    }

    const control = editor.control;
    if (control.model.name === name) {
      return of(name);
    }

    if (name && editor.settings && editor.settings.reg) {
      const reg = editor.settings.reg;
      if (!reg.test(name)) {
        return this.nameError(`${editor.caption}å¿é¡»æ¯å¿é¡»ä»¥å­æ¯å¼å¤´,å­æ¯åæ°å­ç»å`);
      }
    }

    const index = this._controlNames.findIndex((s) => s === name);
    if (index > -1) {
      return this.nameError(`${editor.caption}å·²å­å¨`);
    }

    // ä»åæ¥åè¡¨ä¸­æ·»å ç§»é¤æ§ä»¶çidCode
    if (control.model.name) {
      this._controlNames = this._controlNames.filter((s) => s !== control.model.name);
    }
    // å ä¸å½åçIdCode
    this._controlNames.push(name);
    return of(name);
  }

  private handleCasCadeParentName(
    value: OptionProperty[],
    editor: AbstractPropertyEditor
  ): Observable<OptionProperty[]> {
    const tabData: OptionProperty = value.find((s) => s.id === 'custom');
    if (!tabData.value) {
      return of(value);
    }
    const nameList: string[] = tabData.value.split(/[\n]/).map((s: any) => {
      return s.split('.')[0];
    });
    if (nameList.length > 10) {
      return this.nameError<OptionProperty[]>(`çº§èä¸çº§æ§ä»¶çæ°éä¸è½è¶è¿10ä¸ª`);
    }

    for (const name of nameList) {
      const index = this._controlNames.findIndex((s) => s === name);
      if (index === -1) {
        return this.nameError<OptionProperty[]>(`${editor.caption}${name}ä¸å¯ä½¿ç¨`);
      }
    }
    return of(value);
  }

  private handleUnionCheckName(value: any, validator: AbstractValidatorEditor<any>): Observable<any> {
    const name = value.data.unionId;
    if (!name) {
      return of(value);
    }
    if (this._controlNames.findIndex((s) => s === name) === -1) {
      return this.nameError<any>(`${validator.caption}${name}ä¸å¯ä½¿ç¨`);
    }

    return of(value);
  }

  /**
   * æ§ä»¶åç§°æç¤ºéè¯¯ä¿¡æ¯
   *
   */
  private nameError<T = string>(msg: string): Observable<T> {
    const sub = new Subject<T>();
    this.commonConfig.log.error(msg);
    sub.error('');
    sub.complete();
    return sub;
  }

  private setControlIdentityCode(control: AbstractControl<ControlViewModel>) {
    if (!control.model) {
      return;
    }
    if (!control.model.__identityCode) {
      control.model.__identityCode = this.getUniqueCode();
    }
    if (this._controlIdentityCodes.includes(control.model.__identityCode)) {
      control.model.__identityCode = '';
      throw new Error('control __identityCode exist');
    }

    this._controlIdentityCodes.push(control.model.__identityCode);
  }

  private getUniqueCode(): string {
    const code = getIdentityCode();
    if (this._controlIdentityCodes.includes(code)) {
      return this.getUniqueCode();
    }
    return code;
  }
}
